import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Button,
	Modal,
	ModalBody,
	Col,
	Row,
	Container,
	ModalHeader,
	ModalFooter,
	ListGroup,
	ListGroupItem,
	ListGroupItemHeading,
	ListGroupItemText,
} from 'reactstrap';

import './EmissoesErro.scss';

const mensagemErroUsuario = (codigo, erro) => {
	const mensagem = erro || 'Não foi possível emitir a guia.';
	const mensagemNormalizada = mensagem.toLowerCase();
	const codigoNormalizado = String(codigo || '');

	if (
		mensagemNormalizada.includes('cvc-') ||
		mensagemNormalizada.includes('facet-valid') ||
		mensagemNormalizada.includes('pattern-valid') ||
		mensagemNormalizada.includes('conteudo do xml') ||
		mensagemNormalizada.includes('conteúdo do xml') ||
		mensagemNormalizada.includes('type ')
	) {
		return 'O documento fiscal possui uma informação em formato não aceito pela SEFAZ para emissão da guia. Revise os dados do XML e tente novamente.';
	}

	if (
		codigoNormalizado === '700' ||
		mensagemNormalizada.includes('valor informado menor') ||
		mensagemNormalizada.includes('valor devido') ||
		mensagemNormalizada.includes('valor a ser pago')
	) {
		const valorMinimo = mensagem.match(/mínimo\s+R\$\s*[\d.,]+/i) || mensagem.match(/minimo\s+R\$\s*[\d.,]+/i);
		const complemento = valorMinimo ? ` O ${valorMinimo[0].replace(/minimo/i, 'mínimo')} não foi atingido.` : '';

		return `O valor da guia ficou abaixo do mínimo aceito pela SEFAZ.${complemento} Revise os valores do documento fiscal e tente novamente.`;
	}

	return mensagem.replace(/\s*\([^)]*\)\s*-\s*item\s*$/i, '').trim();
};

class EmissoesErro extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	render() {
		const {
			value: { strCodigoErro, strErro },
		} = this.props;
		const erroParaUsuario = mensagemErroUsuario(strCodigoErro, strErro);

		return (
			<Modal
				size="lg"
				id="modal-emissoes-erro"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.props.onClosed}
				backdrop="static">
				<ModalHeader className="bg-danger">
					<p>Lote recusado</p>
				</ModalHeader>
				<ModalBody>
					<ListGroup>
						<ListGroupItem>
							<ListGroupItemHeading>Código do Erro</ListGroupItemHeading>
							<ListGroupItemText>{strCodigoErro}</ListGroupItemText>
						</ListGroupItem>
						<ListGroupItem>
							<ListGroupItemHeading>Descrição do Erro</ListGroupItemHeading>
							<ListGroupItemText>{erroParaUsuario}</ListGroupItemText>
						</ListGroupItem>
					</ListGroup>
				</ModalBody>
				<ModalFooter>
					<Container>
						<Row>
							<Col className="alert alert-danger">
								<strong>Obs: </strong>Caso necessite de suporte técnico referente a esta guia rejeitada, ressaltamos a necessidade de anexar o xml do documento fiscal em questão.
							</Col>
						</Row>
						<Row className="justify-content-around">
							<Col xs="auto">
								<Button color="info" onClick={() => this.closeModal()}>
									Fechar
								</Button>
							</Col>
						</Row>
					</Container>
				</ModalFooter>
			</Modal>
		);
	}
}

EmissoesErro.propTypes = {
	value: PropTypes.object,
	onClosed: PropTypes.func,
};

export default EmissoesErro;
